// extracted by mini-css-extract-plugin
export default {"SelectionPaperItem":"ActiveDonations_SelectionPaperItem__0arwA"};